'use strict';
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

const _SearchOutlined = _interopRequireDefault(require('./lib/icons/SearchOutlined'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

const _default = _SearchOutlined;
exports.default = _default;
module.exports = _default;